import React, { FC, useEffect, useState } from "react";
import { YhFormItemsBox } from "@/components/YhFormBox";
import { IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { customerService } from "@/views/base/customer/customerService";
import { useOfferDetailModel } from "../offerDetailModel";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export const BaseFormBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
        exchangeRateChange,
        getcurrencySymbol,
        isDisabeld
    } = useOfferDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);

    const { fetchCustomerList,isEditable } = useGlobalModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => []);
    const { beShopDs } = useGlobalModel(({ beShopDs }) => [beShopDs]);
    const formVal = mode === "edit" ? editFormVal : addFormVal;
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            customerId: retData.id,
            phone: retData.phone,
            contact: retData.contact,
            countryCode: retData.countryCode,
            countryName: retData.countryName
        }
        updateFormVal(mode, data)
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }

    //币种选中
    const currencyChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { currencyCode: option.value, currencyName: option.label });
    }
    //国别选中
    const countryChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { countryCode: option.value, countryName: option.label });
    }
    //出口商选中
    const bentityChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { bentityCode: option.value, bentityName: option.label });
    }

    //汇率失焦
    const exchangeRateBlur = (fieldName: string) => {
        let { exchangeRate } = formVal;
        if (!exchangeRate) return;
        //匹配正则就修改加收费用  及 商品明细的单价
        if (/^[0-9]+(.[0-9]{0,5})?$/.test(`${exchangeRate}`)) {
            exchangeRateChange(mode, +exchangeRate)
        }
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-2",
        disabled: isDisabeld(mode),
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "报价单号",
                fieldName: "realCode",
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: <span>客户名称</span>,
                fieldName: "customerCode",
                onSelectChange: customerChange,
                placeholder: "客户",
                rules: [{ required: true, message: "请选择客户" }],
                selectfetchList: fetchCustomerList,
                defaultQuery: formVal.customerName
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                placeholder: "自动带出",
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                placeholder: "自动带出",
                fieldName: "phone",
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "报价日期",
                fieldName: "offerTime",
                rules: [{ required: true, message: "请选择报价日期" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "询价单号",
                fieldName: "inquiryOrderRealCode",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商报价单",
                fieldName: "supplierOfferCode",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "贸易国别",
                fieldName: "countryCode",
                onSelectChange: countryChange,
                options: getSelectedDictOne(DictCodeEnmu.COUNTRY),
                rules: [{ required: true, message: "请选择贸易国别" }],
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "有效日期",
                fieldName: "termTime",
            },
            //  {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "人民币金额",
            //     fieldName: "rmbAmount",
            //     disable: true
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "出口商",
                fieldName: "bentityCode",
                onSelectChange: bentityChange,
                options: beShopDs,
                rules: [{ required: true, message: "请选择出口商" }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货值金额",
                fieldName: "goodsAmount",
                prefix: getcurrencySymbol(mode),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "附加费",
                fieldName: "addAmount",
                prefix: getcurrencySymbol(mode),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "合同总金额",
                fieldName: "contractAmount",
                prefix: getcurrencySymbol(mode),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "汇率",
                fieldName: "exchangeRate",
                onInputBlur: exchangeRateBlur,
                rules: [{ required: true, message: "请输入汇率" }, { pattern: /^[0-9]+(.[0-9]{0,5})?$/, message: '请输入数字且可保留五位小数' }],
                disable: editFormVal.status !== DictCodeEnmu.QUOTE_INIT
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "币种",
                fieldName: "currencyCode",
                onSelectChange: currencyChange,
                options: getSelectedDictOne(DictCodeEnmu.CURRENCY),
                rules: [{ required: true, message: "请选择币种" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 10,
                labelCol: { span: 6 },
                colClassName: "detail-note-col"
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "",
                span: 2,
                labelCol: { span: 16, offset: 8 },
            }, {
                //     type: FormItemTypeEnum.Radio,
                //     fieldLabel: "中间商",
                //     fieldName: "isMiddleman",
                //     radioDs: [{ value: "1", label: "是" }, { value: "0", label: "否" }]
                // }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属部门",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: isEditable,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: isEditable,
                hidden: more
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "欧豪销售单价",
                //     fieldName: "auhowPrice",
                //     disable: true,
                //     hidden: more
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "上浮单价",
                //     fieldName: "upPrice",
                //     disable: true,
                //     hidden: more
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "退税金额",
                //     fieldName: "drawbackAmount",
                //     disable: true,
                //     hidden: more
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "云湖销售单价",
            //     fieldName: "salePrice",
            //     disable: true
            // },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "云泰单价",
            //     fieldName: "ytPrice",
            //     disable: true,
            //     hidden: more
            // },

            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "国别名称",
                fieldName: "countryName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货币名称",
                fieldName: "currencyName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出口商名称",
                fieldName: "bentityName",
                hidden: true
            },
        ]
    };

    return (
        <YhFormItemsBox {...baseFormItem} />
    )
}